(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculadora-nutricional"] && !Shopify.designMode) return;
  try {
    
  /* Uma so funcao para os dois paineis: a diferenca entre proteina e creatina e
     a conta, e a conta vem dos atributos data-* que o Liquid escreve a partir
     das definicoes do editor. Assim os factores mudam no editor sem tocar aqui. */
  function pzCalcularProteina(form, peso) {
    var escolhido = form.querySelector('input[type="radio"]:checked');
    var objetivo = escolhido ? escolhido.value : 'hipertrofia';
    var mapa = {
      definicao: parseFloat(form.dataset.factorDefinicao),
      manutencao: parseFloat(form.dataset.factorManutencao),
      hipertrofia: parseFloat(form.dataset.factorHipertrofia)
    };
    var factor = mapa[objetivo] || 2.2;
    return Math.round(peso * factor);
  }

  function pzCalcularCreatina(form, peso) {
    /* O editor guarda em miligramas por quilo (70 mg/kg), porque a Shopify nao
       aceita passos de 0,01 num campo de intervalo. Aqui volta a gramas. */
    var mgPorKg = parseFloat(form.dataset.factorCreatina) || 70;
    var minimo = parseFloat(form.dataset.minimoCreatina) || 3;
    return Math.max(minimo, Math.round(peso * mgPorKg / 1000));
  }

  function pzLigarCalculadora(form) {
    if (form.dataset.pzLigado) return;
    form.dataset.pzLigado = 'true';

    var tipo = form.dataset.pzCalc;
    var campo = form.querySelector('input[type="number"]');
    var saida = form.querySelector('.pz-calc__resultado');
    var valor = form.querySelector('[data-pz-valor]');
    var erro = form.querySelector('[data-pz-erro]');

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();
      var peso = parseFloat(String(campo.value).replace(',', '.'));

      /* Um peso fora de 20 a 250 kg nao e um peso: e um erro de digitacao, e
         devolver uma dose a partir dele seria pior do que nao devolver nada. */
      if (!peso || peso < 20 || peso > 250) {
        saida.hidden = true;
        erro.hidden = false;
        campo.focus();
        return;
      }

      erro.hidden = true;
      valor.textContent = tipo === 'creatina'
        ? pzCalcularCreatina(form, peso)
        : pzCalcularProteina(form, peso);
      saida.hidden = false;
    });

    /* Mudar o peso ou o objetivo depois de calcular esconde o resultado
       anterior, para nao ficar um numero antigo ao lado de dados novos. */
    form.addEventListener('input', function () {
      saida.hidden = true;
    });
  }

  function pzLigarCalculadoras() {
    document.querySelectorAll('[data-pz-calc]').forEach(pzLigarCalculadora);
  }

  document.addEventListener('DOMContentLoaded', pzLigarCalculadoras);
  document.addEventListener('shopify:section:load', pzLigarCalculadoras);
  pzLigarCalculadoras();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rastreio-encomenda"] && !Shopify.designMode) return;
  try {
    
  function pzLigarRastreio(form) {
    if (form.dataset.pzLigado) return;
    form.dataset.pzLigado = 'true';

    var campo = form.querySelector('input[name="codigo"]');
    var erro = form.querySelector('[data-pz-erro]');

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();

      /* Os codigos vem colados de um email e trazem espacos no fim mais vezes
         do que se imagina. */
      var codigo = (campo.value || '').trim().replace(/\s+/g, '');

      if (codigo.length < 6) {
        erro.hidden = false;
        campo.focus();
        return;
      }

      erro.hidden = true;
      var destino = form.dataset.pzRastreio.replace('{codigo}', encodeURIComponent(codigo));
      window.open(destino, '_blank', 'noopener');
    });
  }

  function pzLigarRastreios() {
    document.querySelectorAll('form[data-pz-rastreio]').forEach(pzLigarRastreio);
  }

  document.addEventListener('DOMContentLoaded', pzLigarRastreios);
  document.addEventListener('shopify:section:load', pzLigarRastreios);
  pzLigarRastreios();

  } catch(e) { console.error(e); }
})();
})();
